import { Steps } from "./types";

export const disqualificationSteps: Steps = {
  d1: {
    id: "d1",
    slug: "complete-2",
    text: "Du är för ung för att söka blodtrycksvård hos oss",
    type: "disqualification",
    disqualificationType: "ageUnder35",
    nextStep: () => null,
  },
  d2: {
    id: "d2",
    slug: "complete-3",
    text: "Ditt BMI är inte tillräckligt högt",
    clarification:
      "För att ta del av behandlingen krävs ett BMI över 30, alternativt ett BMI över 27 i kombination med andra riskfaktorer såsom högt blodtryck och höga blodfetter.",
    type: "disqualification",
    disqualificationType: "bmi",
    nextStep: () => null,
  },
  d3: {
    id: "d3",
    slug: "complete-4",
    text: "Du uppfyller inte villkoren för medicinsk behandling mot övervikt",
    subText:
      "Enligt riktlinjer för medicinsk behandling av övervikt måste något av följande uppfyllas:",
    clarification: [
      "Du har ett BMI mellan 27 och 30 och minst en viktrelaterad sjukdom, såsom högt blodtryck, diabetes typ 2, förhöjda blodfetter eller obstruktiv sömnapné.",
      "Du har ett BMI på 30 eller högre.",
    ],
    type: "disqualification",
    disqualificationType: "noRiskRactors",
    nextStep: () => null,
  },
  d4: {
    id: "d4",
    slug: "complete-5",
    text: "",
    clarification: "",
    type: "disqualification",
    disqualificationType: "lowRisk",
    nextStep: () => null,
  },
  d5: {
    id: "d5",
    slug: "complete-6",
    text: "Diskvalificerad pga. ålder",
    type: "disqualification",
    disqualificationType: "ageUnder18",
    nextStep: () => null,
  },
};
